export const NoneOptionID = 'NONE-ID';
export const CPT_LABEL_PAGE_COUNT = 100;
export const ACTIVITY_BILLING_PAGE_COUNT = 100;
